import { createContext, useEffect, useState } from 'react';
import { UserData } from '../models/UserData';
import { getUserData } from '../services';
type Props = {
  children: any;
};
type userContextType = {
  userData: UserData;
  dispatch: () => void;
};
const userContextDefault: userContextType = {
  userData: {
    IsLoggedIn: false,
    DisplayName: '',
    CompanyName: null,
    CustomerId: 0,
    Email: null,
    Name: null,
    wasFetched: undefined
  },
  dispatch: () => {}
};
export const AuthContext = createContext(userContextDefault);
const AuthContextProvider: React.FC<Props> = ({ children }) => {
  //set User Logged in or not
  const [userData, setUserData] = useState<UserData>({
    IsLoggedIn: false,
    DisplayName: '',
    CompanyName: null,
    CustomerId: 0,
    Email: null,
    Name: null
  });
  const dispatch = async () => {
    const newData = await getUserData();
    const checkUser = { ...newData, wasFetched: newData.IsLoggedIn };
    setUserData(checkUser);
  };
  useEffect(() => {
    dispatch();
  }, []);
  return (
    <AuthContext.Provider value={{ userData, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContextProvider;
